(() => {
  'use strict';
  if (window.LowkratiefMasterFlipV1) return;
  window.LowkratiefMasterFlipV1 = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { entry.target.dataset.lkMasterVisible = String(entry.isIntersecting); });
  }, { threshold: 0.08 }) : null;
  const watch = el => {
    if (observer) observer.observe(el);
    else el.dataset.lkMasterVisible = 'true';
  };
  const canAdvance = el => !document.hidden && el.isConnected &&
    el.dataset.lkMasterVisible !== 'false' &&
    !el.matches(':hover, :focus-within');
  const init = (root = document) => {
    if (!document.body.classList.contains('template-index')) return;
    root.querySelectorAll('.lk26-card').forEach(card => {
      if (card.dataset.lkMasterFlip || !card.querySelector('.lk26-card-back')) return;
      card.dataset.lkMasterFlip = 'active';
      watch(card);
      window.setInterval(() => {
        if (!canAdvance(card)) return;
        const flipped = !card.classList.contains('is-flipped');
        card.classList.toggle('is-flipped', flipped);
        const button = card.querySelector('.lk26-flip');
        if (button) button.setAttribute('aria-pressed', String(flipped));
      }, 5000);
    });
    root.querySelectorAll('.lk27-studio-product').forEach(panel => {
      if (panel.dataset.lkMasterFlip) return;
      const image = panel.querySelector('.lk27-viewer-image');
      if (!image || !image.querySelector('.lk27-view-front') || !image.querySelector('.lk27-view-back')) return;
      panel.dataset.lkMasterFlip = 'active';
      watch(panel);
      window.setInterval(() => {
        if (panel.hidden || !canAdvance(panel)) return;
        const next = image.dataset.side === 'front' ? 'back' : 'front';
        image.dataset.side = next;
        panel.querySelectorAll('.lk27-side-buttons button[data-side]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.side === next));
        });
      }, 5000);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
/* Single-line free-shipping threshold, synchronized with Shopify cart. */
(() => {
  'use strict';
  if (window.LowkratiefShippingLiveV3) return;
  window.LowkratiefShippingLiveV3 = true;
  const banner = document.querySelector('[data-lk-shipping-threshold]');
  if (!banner) return;
  const label = banner.querySelector('[data-lk-shipping-copy]');
  const threshold = Number(banner.dataset.lkShippingThreshold);
  if (!label || !Number.isFinite(threshold) || threshold <= 0) return;
  const format = cents => new Intl.NumberFormat('de-DE', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2
  }).format(cents / 100);
  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = root + 'cart.js';
  let timer;
  let requestId = 0;
  const render = cart => {
    const total = Number(cart?.total_price);
    if (!Number.isFinite(total)) return;
    const activeCode = (Array.isArray(cart.discount_codes) && cart.discount_codes.some(c => c && c.applicable !== false)) ||
      (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.some(c => c?.type === 'discount_code'));
    const amount = Math.max(0, threshold - total);
    label.textContent = activeCode ? 'Rabattcode aktiv' :
      amount > 0 ? 'Nur noch ' + format(amount) + ' bis Gratisversand DE' : 'Gratisversand DE erreicht';
    banner.style.setProperty('--lk-master-shipping-progress', activeCode ? '0' :
      String(Math.min(1, Math.max(0, total / threshold))));
  };
  const refresh = async () => {
    const id = ++requestId;
    try {
      const result = await window.fetch(cartUrl, {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept:'application/json' }
      });
      if (!result.ok) return;
      const data = await result.json();
      if (id === requestId) render(data);
    } catch (_) {}
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 180); };
  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function(request, options) {
      const result = originalFetch.apply(this, arguments);
      const url = typeof request === 'string' ? request : request?.url || '';
      const method = String(options?.method || request?.method || 'GET').toUpperCase();
      if (method !== 'GET' && ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'].some(p => url.includes(p))) {
        result.then(response => { if (response.ok) schedule(); }).catch(() => {});
      }
      return result;
    };
  }
  document.addEventListener('cart:updated', event => {
    if (event.detail?.cart?.total_price != null) render(event.detail.cart);
    else schedule();
  });
  ['ajaxProduct:added','cart:refresh','cart:change','shopify:section:load'].forEach(ev => document.addEventListener(ev, schedule));
  document.addEventListener('submit', event => {
    if (event.target?.matches?.('form[action*="/cart/add"]')) {
      setTimeout(schedule, 450); setTimeout(schedule, 1100);
    }
  }, true);
  window.addEventListener('pageshow', schedule);
  refresh();
})();